export default __webpack_public_path__ + "static/media/ObroundTank_ti40043.ad4192bd.png";